import {CoachInfoCard} from '/constant/TestIDs';
import {
  REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK,
  REPORT_CLOSE_TO_FIBC_RANK,
  REPORT_CLOSE_TO_SENIOR_COACH_RANK,
} from '/enum/records.enum';
import {withTranslation} from '/provider/TranslationProvider';

import CertificationContent from '../CertificationContent';
import PeopleListContent from '../PeopleListContent';
import ProgressBarContent from '../ProgressBarContent';
import QualifyingPointsContent from '../QualifyingPointsContent';

const tt = (key: any, value: any) =>
  withTranslation.tt(`closeToCompetencyContent.${key}`, value);

export default {
  certification: {
    dataComponent: CertificationContent,
    isComplete: ({certified}: any) => certified,
    sortOrder: 5,
    presentedFor: [REPORT_CLOSE_TO_FIBC_RANK],
    testID: CoachInfoCard.certificationContent,
  },
  gqv: {
    dataComponent: ProgressBarContent,
    titleProps: {
      getTitle: () => tt('title.gqv', 'Group Qualifying Volume'),
    },
    isComplete: ({current, target}: any) =>
      parseInt(current, 10) >= parseInt(target, 10),
    sortOrder: 5,
    presentedFor: [
      REPORT_CLOSE_TO_SENIOR_COACH_RANK,
      REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK,
      REPORT_CLOSE_TO_FIBC_RANK,
    ],
    testID: CoachInfoCard.gqvContent,
  },
  fqv: {
    dataComponent: ProgressBarContent,
    titleProps: {
      getTitle: () => tt('title.fqv', 'Frontline Qualifying Volume'),
    },
    isComplete: ({current, target}: any) =>
      parseInt(current, 10) >= parseInt(target, 10),
    sortOrder: 4,
    presentedFor: [],
    testID: CoachInfoCard.fqvContent,
  },
  orderingEntities: {
    dataComponent: PeopleListContent,
    titleProps: {
      getTitle: () => tt('title.orderingEntities', 'Ordering Entities'),
    },
    isComplete: ({currentCount, target}: any) => currentCount >= target,
    sortOrder: 1,
    presentedFor: [
      REPORT_CLOSE_TO_SENIOR_COACH_RANK,
      REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK,
      REPORT_CLOSE_TO_FIBC_RANK,
    ],
    testID: CoachInfoCard.oeContent,
  },
  qualifyingPoints: {
    dataComponent: QualifyingPointsContent,
    isComplete: ({current, target}: any) => current >= target,
    sortOrder: 3,
    presentedFor: [REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK],
    testID: CoachInfoCard.qualifyingPointsContent,
  },
  seniorCoachTeams: {
    dataComponent: PeopleListContent,
    titleProps: {
      getTitle: () => tt('title.seniorCoachTeams', 'Senior Coach Teams'),
    },
    isComplete: ({currentCount, target}: any) => currentCount >= target,
    sortOrder: 2,
    presentedFor: [REPORT_CLOSE_TO_FIBC_RANK],
    testID: CoachInfoCard.seniorCoachTeamsContent,
  },
};
